// Client-side mirror of server/bruto.js. Used ONLY for live preview in the UI —
// the value stored in the database is always the server's.
export const BRUTO_RULE_START = '2026-09-01';
export const BRUTO_RULE_START_LABEL = '01/09/2026';
export const DEFAULT_MULTIPLIER = 1.2;

// 'DD/MM/YYYY' or ISO -> 'YYYY-MM-DD' (or null)
export function normalizeEntryDate(value) {
  if (!value || typeof value !== 'string') return null;
  let m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  m = value.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (!m) return null;
  const day = Number(m[1]);
  const month = Number(m[2]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

// Entry date = `date`, falling back to `dateCreated`.
export function resolveEntryDate(entry) {
  return normalizeEntryDate(entry && entry.date) || normalizeEntryDate(entry && entry.dateCreated);
}

export function isBrutoRuleActive(entryDateISO) {
  return Boolean(entryDateISO) && entryDateISO >= BRUTO_RULE_START;
}

// Nearest half hour; exact quarters round up (9.2 -> 9.0, 9.3 -> 9.5). Mirrors the server.
export function roundToHalf(n) {
  return Math.round((Math.round((Number(n) + Number.EPSILON) * 100) / 100) * 2) / 2;
}

export function previewBruto(neto, multiplier, entryDateISO) {
  const n = Number(neto);
  if (!Number.isFinite(n)) return 0;
  if (!isBrutoRuleActive(entryDateISO)) return roundToHalf(n);
  const m = Number.isFinite(Number(multiplier)) ? Number(multiplier) : DEFAULT_MULTIPLIER;
  return roundToHalf(n * m);
}

export const getCategoryName = (category) => {
  if (!category) return '';
  if (typeof category === 'object') return category.name || '';
  return category;
};

export const formatHours = (value) => (Number(value) || 0).toFixed(1);
